<div class="content-heading">
  <div class="header-container">
    <h3>Producto Temporales</h3>
    <small>Añadir productos al sistema de CEQ o rechazar la alta.</small>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-body">
          <form [formGroup]="FormProductTemp" (ngSubmit)="formSubmit()">
            <div class="row">

              <div class="col-lg-3 col-md-12 text-center">
                <label class="form-label">Código de barras</label>
                <div class="d-flex justify-content-center p-3 bg-light rounded">
                  <ngx-barcode6 
                    [bc-format]="'CODE128'" 
                    [bc-value]="product.ProductBarcode"
                    [bc-display-value]="true" 
                    [bc-width]="1.5" 
                    [bc-height]="60">
                  </ngx-barcode6>
                </div>
              </div>

              <div class="col-lg-9 col-md-12">
                <div class="row">
                  <div class="col-lg-6 col-md-6">
                    <aph-custom-text label="Producto" formControlName="ProductDescription" style="border:none;"></aph-custom-text>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <aph-custom-text label="Nombre corto" formControlName="ProductName" style="border:none;"></aph-custom-text>
                  </div>

                  <div class="col-lg-4 col-md-4">
                    <aph-custom-text label="Planta ID" formControlName="ItemPlantaId" style="border:none;"></aph-custom-text>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <aph-custom-text label="Código" formControlName="ProductCode" style="border:none;"></aph-custom-text>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <aph-custom-text label="Tipo" formControlName="ProductType" style="border:none;"></aph-custom-text>
                  </div>

                  <div class="col-lg-4 col-md-4">
                    <aph-custom-text label="Precio" type="currency"  formControlName="ProductPrice" style="border:none;"></aph-custom-text>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <aph-custom-text label="Cupo" type="numeric" [allowDecimal]="false" [allowNegative]="false" formControlName="ProductConversion" style="border:none;"></aph-custom-text>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <aph-custom-text label="Peso" type="numeric" [allowDecimal]="true" [allowNegative]="false" formControlName="ProductWeight" style="border:none;"></aph-custom-text>
                  </div>

                  <div class="col-lg-4 col-md-4">
                    <label class="form-label">Contenedor</label>
                    <aph-custom-select 
                      [items]="containerList" 
                      bindLabel="ContainerDescription" 
                      bindValue="ContainerCode"
                      formControlName="ProductContainer"
                      placeholder="Seleccione contenedor..."
                      style="border:none;">
                    </aph-custom-select>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <label class="form-label">Envases</label>
                    <aph-custom-select 
                      [items]="containerList2" 
                      bindLabel="ContainerDescription" 
                      bindValue="ContainerCode"
                      formControlName="ProductUom"
                      placeholder="Seleccione envase..."
                      style="border:none;">
                    </aph-custom-select>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <aph-custom-text label="Tiempo de Vida (Días)" formControlName="ProductLifeDays" style="border:none;"></aph-custom-text>
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <div class="row mt-3">
              <div class="col-12 d-flex flex-wrap">
                <aph-custom-buttons 
                  preset="save" 
                  label="Guardar" 
                  type="submit" 
                  [disabled]="disabledArt || FormProductTemp.invalid"
                  class="mr-2">
                </aph-custom-buttons>

                <aph-custom-buttons 
                  preset="delete" 
                  label="Rechazar" 
                  (btnClick)="delete()" 
                  [disabled]="disabledArt"
                  class="mr-2">
                </aph-custom-buttons>

                <aph-custom-buttons 
                  preset="exit" 
                  label="Salir" 
                  (btnClick)="btnCancelOnClick()">
                </aph-custom-buttons>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>